import { ErrorHandler, Provider } from '@angular/core';
import { SentryService } from '@bca-core/services/sentry.service';

export class SentryErrorHandler implements ErrorHandler {
  constructor(private readonly _sentry: SentryService) {}

  handleError(error: Error): void {
    if (this._sentry) {
      this._sentry.logError(error);
      throw error;
    } else {
      console.trace(error);

    }

  }
}

export function errorHandlerFactory(sentry: SentryService): ErrorHandler {
  return new SentryErrorHandler(sentry);
}

export function provideErrorHandler(): Provider {
  return {
    provide: SentryErrorHandler,
    useFactory: errorHandlerFactory,
    deps: [SentryService]
  };
}
